export default __webpack_public_path__ + "static/media/texture-wood-1x.87d0cbea.png";